<template>
  <div>
    <section class="error">
      <b-container>
        <h1 class="error__title">404</h1>
        <p class="error__text">Page not found</p>
        <b-row class="justify-content-center mt-5">
          <router-link to="/" class="main-button">Home page</router-link>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
export default {
  name: 'PageNotFound'
}
</script>
